export const GETUSER_REQUEST = 'GetUserRequestAction';
export const GETUSER_RECEIVED = 'GetUserReceivedAction';

export const DefaultUserModel = {
    isAuthenticated: false,
    email: 'undefined',
    firstName: 'undefined',
    lastName: 'undefined',
    phoneNumber:' undefined',
    userId: 'undefined'
};

export const userReducer = (state = DefaultUserModel, action) => {
    const resetState = {
      isAuthenticated: false,
      email: 'undefined',
      firstName: 'undefined',
      lastName: 'undefined',
      phoneNumber:' undefined',
      userId: 'undefined'
    };
    switch (action.type) {
        case GETUSER_REQUEST:
            return state;
        case GETUSER_RECEIVED:
            return action.payload;
      default:
        //const exhaustiveCheck: never = action;
        break;
    }
    return state || DefaultUserModel;
};


